var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { singleton } from "tsyringe";
let MenuSearchService = class MenuSearchService {
    search(items, query) {
        const normalizedQuery = this.normalize(query);
        if (normalizedQuery.length < 3)
            return [];
        return items
            .filter((item) => this.normalize(item.name).includes(normalizedQuery))
            .map((item) => ({ item }));
    }
    normalize(text) {
        return (text
            .toLowerCase() // case-insensitive matching
            // Simple way of handling diacritics (ą, ź, ś, ć, ł). Can be improved with a library if needed
            .normalize("NFD") // decompose accented chars into base + diacritic codepoints
            .replace(/[\u0300-\u036f]/g, "") // strip diacritics → é→e, ą→a, ó→o, etc.
            .replace(/\u0142/g, "l") // `ł` doesn't decompose via NFD, handle it explicitly
            .trim() // ignore surrounding whitespace
        );
    }
};
MenuSearchService = __decorate([
    singleton()
], MenuSearchService);
export { MenuSearchService };
